import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { HomeScreen } from '../screens/HomeScreen';
import { ScanScreen } from '../screens/ScanScreen';
import { DiscoveringScreen } from '../screens/DiscoveringScreen';
import { RosterPickScreen } from '../screens/RosterPickScreen';
import { NameEntryScreen } from '../screens/NameEntryScreen';
import { StudentSuggestionScreen } from '../screens/StudentSuggestionScreen';
import { TaskQueueScreen } from '../screens/TaskQueueScreen';
import { ActiveLessonScreen } from '../screens/ActiveLessonScreen';
import { LessonCompleteScreen } from '../screens/LessonCompleteScreen';
import { LoadingScreen } from '../screens/LoadingScreen';
import { FreestyleCurriculumScreen } from '../screens/FreestyleCurriculumScreen';
import { FreestyleActiveScreen } from '../screens/FreestyleActiveScreen';
import { FreestyleSummaryScreen } from '../screens/FreestyleSummaryScreen';
import { RootStackParamList } from './types';

const Stack = createStackNavigator<RootStackParamList>();

export const AppNavigator = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="Home" component={HomeScreen} />
            <Stack.Screen name="Scan" component={ScanScreen} />
            <Stack.Screen name="Discovering" component={DiscoveringScreen} />
            <Stack.Screen name="RosterPick" component={RosterPickScreen} />
            <Stack.Screen name="NameEntry" component={NameEntryScreen} />
            <Stack.Screen name="StudentSuggestion" component={StudentSuggestionScreen} />
            <Stack.Screen name="TaskQueue" component={TaskQueueScreen} />
            <Stack.Screen name="ActiveLesson" component={ActiveLessonScreen} />
            <Stack.Screen name="LessonComplete" component={LessonCompleteScreen} />
            <Stack.Screen name="Loading" component={LoadingScreen} />
            <Stack.Screen name="FreestyleCurriculum" component={FreestyleCurriculumScreen} />
            <Stack.Screen name="FreestyleActive" component={FreestyleActiveScreen} />
            <Stack.Screen name="FreestyleSummary" component={FreestyleSummaryScreen} />
        </Stack.Navigator>
    );
};
